import countyZipRegexMap from '../config/zip-country-regexp';

var handleSelect = function (form, formSection, stateLabelId, countryLabelId, keepSelectValue) {
  function getAttributes($node) {
    if (!$node || $node.length === 0) {
      return;
    }
    var attrs = {};
    $.each($node[0].attributes, function (index, attribute) {
      attrs[attribute.name] = attribute.value;
    });
    return attrs;
  }

  form = $(form);
  var countriesStates = form.data('countriesstates');
  var selectDefaultLabel = form.data('selectdefaultlabel');

  if (formSection) {
    form = form.find(formSection);
  }

  var selectedCountry = form.find(`label#${countryLabelId} input`).val();
  if (form.find(`label#${countryLabelId} select`).length) {
    selectedCountry = form.find(`label#${countryLabelId} select`).val();
  }

  var selectedState = form.find(`label#${stateLabelId} input`).val();
  if (form.find(`label#${stateLabelId} select`).length) {
    selectedState = form.find(`label#${stateLabelId} select`).val();
    if (stateLabelId === 'shippingStateLabel') {
      if (selectedState === '') {
        var state = $('select[name="addressSelector"]');
        var shipmentID = $('input[name="shipmentUUID"]').val();
        if (state.length > 0 && shipmentID.length > 0 && state.find('option[value="' + shipmentID + '"]').prop('selected')) {
          var selectedState = state.find('option[value="' + shipmentID + '"]').attr('data-state-code') || '';
        }
      } else {
        var addressSelector = $('.shipment-selector-block');
        if (addressSelector.length > 0) {
          var selectedAddress = addressSelector.find('ul.shipping-address-selector li.selected input');
          if (selectedAddress.length > 0) {
            var selectedState = selectedAddress.attr('data-state-code') || '';
          } else {
            var state = $('select[name="addressSelector"]');
            var shipmentID = $('input[name="shipmentUUID"]').val();

            if (state.length > 0 && shipmentID.length > 0) {
              var optionSelected = state.find('option[value="' + shipmentID + '"]');
              if (optionSelected.length > 0) {
                var selectedState = state.find('option[value="' + shipmentID + '"]').attr('data-state-code') || '';
              }
            }
          }
        }
      }

    }
  }

  if (selectedCountry && form.find('#shippingShipToStoreAccessPointsZipCode').length) {
    // update cap
    var zipRegex = countyZipRegexMap[selectedCountry];
    if (zipRegex) {
      form.find('#shippingShipToStoreAccessPointsZipCode').attr('pattern', zipRegex);
    }
  }

  var attributes;

  if (countriesStates) {
    if (countriesStates.hasOwnProperty(selectedCountry)) {
      if (form.find(`label#${stateLabelId} input`).length) {
        attributes = getAttributes(form.find(`label#${stateLabelId} input`));
      } else {
        attributes = getAttributes(form.find(`label#${stateLabelId} select`));
      }
      delete attributes.type;
      if (!keepSelectValue) {
        delete attributes.value;
      }

      form.find(`label#${stateLabelId} input`).remove();
      form.find(`label#${stateLabelId} select`).remove();
      form.find(`label#${stateLabelId} div`).remove();

      var isStateNotRequired = false; // Without some exceptions, state select is always required

      var activeTab = $('div.shipping-address').find('li.is-current').data('target');

      // Always required except if regular shipping and initing access points or not regular shipping and initing simple shipping
      isStateNotRequired = (activeTab === 'checkout-shipping-delivery' && stateLabelId === 'stateLabelAccessPoint')
        || (activeTab !== 'checkout-shipping-delivery' && stateLabelId === 'shippingStateLabel')
        || (activeTab === 'checkout-shipping-store' && formSection !== '.shipping-address-store-block')
        || (activeTab === 'checkout-shipping-accesspoint' && formSection !== '.shipping-address-accesspoints-block');
      if(!isStateNotRequired){
          let label = form.find(`label#${stateLabelId}`)
          label.text(label.text().trim().replace('*', '') + '*');
      }
      form.find(`label#${stateLabelId}`).append(`<select ${!isStateNotRequired ? 'required="required"' : ''}></select>`);

      for (let key of Object.keys(attributes)) {
        if (key !== 'required') {
          $(`label#${stateLabelId} select`).attr(key, attributes[key]);
        }
      }

      form.find(`label#${stateLabelId} select`).append(`<option id="pick-a-state" value="">${selectDefaultLabel}</option>`);
      countriesStates[selectedCountry].map((state) => {
        form.find(`label#${stateLabelId} select`).append(`<option id="${state.id}" value="${state.htmlValue}" ${(keepSelectValue && state.id === selectedState) ? 'selected' : ''}>${state.label}</option>`);
      });

      var label = form.find(`label#${stateLabelId}`);
      label.closest('div').removeClass('hide');
      //TODO: TSKY-22 - delete this block if tests are successful
      /*form.find(`label#${stateLabelId} select`).customSelect({
        transition: 300,
        modifier: 'expanded'
      });*/
      // state select is outside of select plugin, the following code make the select refresh on select change
      // useful for autocomplete purposes
      /*form.find(`label#${stateLabelId} select`).on('change', function (e) {
        if ($(e.currentTarget).data('custom-select')) {
          var customSelect = $(e.currentTarget).data('custom-select')._$element;
          $(e.currentTarget).removeData('custom-select');
          $(customSelect).remove();
        }

        $(e.currentTarget).customSelect({
          transition: 300,
          modifier: 'expanded'
        });
      });*/
    } else {
      let label = form.find(`label#${stateLabelId}`);
      label.closest('div').addClass('hide');
      document.getElementById('billingState').value="";
      document.getElementById('billingState').removeAttribute("required");

      /* if (form.find(`label#${stateLabelId} input`).length) {
        attributes = getAttributes(form.find(`label#${stateLabelId} input`));
      } else {
        attributes = getAttributes(form.find(`label#${stateLabelId} select`));
        if (!attributes) {
          console.error(`element "label#${stateLabelId} select" not found`);
          return;
        }
      }
      attributes.type = 'text';
      delete attributes.style;
      if (!keepSelectValue) {
        delete attributes.value;
      }

      form.find(`label#${stateLabelId} input`).remove();
      form.find(`label#${stateLabelId} select`).remove();
      form.find(`label#${stateLabelId} div`).remove();
      form.find(`label#${stateLabelId}`).append('<input></input>');

      for (let key of Object.keys(attributes)) {
        if (key !== 'required') {
          $(`label#${stateLabelId} input`).attr(key, attributes[key]);
        }
      } */

    }
  }
};

var autoFillFields = function (fieldsWrapper, fieldIdPrefix, data) {
  for (var prop in data) {
    $(fieldsWrapper).find(fieldIdPrefix + (prop[0].toUpperCase() + prop.slice(1))).val(data[prop]);
    if(prop === 'email') $(fieldsWrapper).find(fieldIdPrefix + (prop[0].toUpperCase() + prop.slice(1))).change();
  }
};

var resetFields = function (fieldsWrapper) {
  $(fieldsWrapper).find('input').val('');
  $(fieldsWrapper).parent().find('input').val('');
  $(fieldsWrapper).parent().parent().find('input')
    .val('');
  $(fieldsWrapper).parent().parent().parent()
    .find('input')
    .val('');
};

var initStateBasedOnCountry = function (form, formSection, stateLabelId, countryLabelId) {
  handleSelect(form, formSection, stateLabelId, countryLabelId, true);
};

var makeStatesAccortingToCountry = function (e, formSection, stateLabel, countryLabel) {
  var form = $(e.target).parents('form');
  handleSelect(form, formSection, stateLabel, countryLabel, false);
};

module.exports = {
  makeStatesAccortingToCountry: makeStatesAccortingToCountry,
  initStateBasedOnCountry: initStateBasedOnCountry,
  autoFillFields: autoFillFields,
  resetFields: resetFields
};



// WEBPACK FOOTER //
// ./assets/scripts/util/statesAccordingCountry.js